<div class="pageheader">
    <div class="page-title">
        <h1>Tracking Search Views</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">
                <span>Refresh</span>
                <ep-svg-icon icon="repeat"></ep-svg-icon>
            </button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Grid configuration log'">
                <app-change-log-link-entity type="GridConfiguration"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="xcontainer xcontainer-fixed">
    <div class="xrow">
        <div class="col-sm-12">
            <app-tracking-search-views-grid [gridusers]="allUsers" [configs]="configs" [defaultconfigs]="defaultConfigs" (saveView)="onSaveView($event)"
            (deleteView)="onDeleteView($event)">
            </app-tracking-search-views-grid>
        </div>
    </div>
</div>